module.exports = __webpack_public_path__ + "img/map-pin.b14ccbeb.svg";